import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-ivory">
        <Loader2 className="w-6 h-6 animate-spin text-maroon" />
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace state={{ from: loc.pathname }} />;
  return children;
}
